import React, { useMemo } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'

import InlineGroup from 'components/Common/InlineGroup'
import BodyText from 'components/Luxkit/Typography/BodyText'
import BedIcon from 'components/Luxkit/Icons/line/LineBedIcon'
import RoomIcon from 'components/Luxkit/Icons/line/LineDoorIcon'
import { sortBy } from 'lib/arrayUtils'
import { Bedbank } from '@luxuryescapes/contract-svc-bedbank'

const Root = styled(InlineGroup)`
  flex-direction: column;

  > * + * {
    margin-top: ${rem(6)};
  }
`

const Icon = styled.div`
  display: flex;
  width: ${rem(24)};
`

const allowFeatures = {
  room: <RoomIcon size={22} />,
  bed: <BedIcon size="M" />,
}

interface Props {
  features: Bedbank.RoomFeature[];
  className?: string;
}

function BedbankRoomFeatures(props: Props) {
  const { features, className } = props

  const filteredFeatures = useMemo(() => {
    const types = new Set(Object.keys(allowFeatures))
    return sortBy(features.filter(x => types.has(x.id)), (x) => x.id, 'asc')
  }, [features])

  return <Root className={className}>
    {filteredFeatures.map(feature => (
      <InlineGroup key={feature.id} spacing="sm" vertical="center"><Icon>{allowFeatures[feature.id]}</Icon><BodyText variant="medium" weight="semi-bold">{feature.text}</BodyText></InlineGroup>
    ))}
  </Root>
}

export default React.memo(BedbankRoomFeatures)
